import useLongPress from '../../../utils/useLongPress'
import { memo } from 'react';
import { applyChange } from '../../../utils/loadPositions';
import { deleteAllRed, deleteAllOrange, recordDeleteAndMaybePromptByUserId } from '../utils/redDeleteTracker';

const DeleteButton = memo((props) => {
    const erasePosition = props => {
        const { socket, caixaSelected, setCaixaSelected, posicions, assistenciesEvent } = props;
        const room = `${props.selectedEvent}.${props.selectedBundle}.${props.selectedVersio}`;
        const action_id = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);

        const deletedUserId = posicions?.caixes?.[caixaSelected];

        if (Number(props.castellersInfo?.[deletedUserId]?.is_temporary) === 1) {
            props.removeTemporaryPerson(deletedUserId);
            return;
        }

        applyChange(props, `${caixaSelected},_EMPTY_`);
        socket.emit('.save_change_to_room', room, `${caixaSelected},_EMPTY_`, action_id);
        setCaixaSelected(-1);

        // Track consecutive 'No vinc' or 'No confirmat' deletions and maybe prompt
        recordDeleteAndMaybePromptByUserId(deletedUserId, assistenciesEvent, props);
    };

    const handleClick = () => {
        // Permanent accounts are never deleted here. Temporaries use the scoped
        // removal flow, which asks about other proves and provides undo.
        erasePosition(props)
    }

    const hasAssignat = props => {
        const { caixaSelected, posicions } = props;
        return caixaSelected !== -1 && caixaSelected in posicions.caixes;
    };

    const getSelectedUserAssistencia = ({ posicions, assistenciesEvent, caixaSelected }) => {
        const userId = posicions?.caixes?.[caixaSelected];
        return assistenciesEvent?.find(a => a.id === userId)?.['assistència'];
    };

    const isSelectedUserRed = (props) => getSelectedUserAssistencia(props) === 0;
    
    const isSelectedUserOrange = (props) => {
        const assist = getSelectedUserAssistencia(props);
        return assist !== 0 && assist !== 1 && assist !== 2;
    };

    const onLongPressDeleteAll = (props) => {
        if (isSelectedUserRed(props)) {
            deleteAllRed(props);
        } else if (isSelectedUserOrange(props)) {
            deleteAllOrange(props);
        }
    };

    const longPressEvent = useLongPress(
        () => onLongPressDeleteAll(props),
        () => undefined,
        500
    );

    return (
        <div
            className={`floating-button delete ${!hasAssignat(props) ? 'hidden' : ''}`}
            role="button" tabIndex={hasAssignat(props) ? 0 : -1} aria-label="Treure de la caixa"
            onKeyDown={event => { if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); event.stopPropagation(); handleClick(event); } }}
            onKeyUp={event => event.stopPropagation()}
            onClick={handleClick}
            /*onLongPress=*/{...longPressEvent}
        >
            &#128465;
        </div>
    );
}, (prevProps, nextProps) =>
    prevProps.castellersInfo === nextProps.castellersInfo &&
    prevProps.removeTemporaryPerson === nextProps.removeTemporaryPerson &&
    prevProps.caixaSelected === nextProps.caixaSelected &&
    JSON.stringify(prevProps.posicions) === JSON.stringify(nextProps.posicions) &&
    JSON.stringify(prevProps.assistenciesEvent) === JSON.stringify(nextProps.assistenciesEvent)
);

export default DeleteButton;
